import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "name",
    "descriptionWrapper",
    "description",
    "type",
    "optionsWrapper",
    "options",
    "filesWrapper",
    "files"
  ]

  show(event) {
    const button = event.relatedTarget
    const requirementData = JSON.parse(button.dataset.requirementData || '{}')

    this.nameTarget.textContent = requirementData.name || 'N/A'

    if (requirementData.description) {
      this.descriptionWrapperTarget.style.display = 'block'
      this.descriptionTarget.textContent = requirementData.description
    } else {
      this.descriptionWrapperTarget.style.display = 'none'
    }

    this.typeTarget.textContent = (requirementData.requirement_type || '')
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase())

    this.optionsTarget.innerHTML = ''
    let hasOptions = false

    if (requirementData.requirement_type === 'payment_product_selection' && requirementData.options?.items) {
      const items = requirementData.options.items
      if (items.length > 0) {
        hasOptions = true
        items.forEach(item => {
          const li = document.createElement('li')
          const prices = []
          if (item.early_price) prices.push('Early: $' + parseFloat(item.early_price).toFixed(2))
          if (item.regular_price) prices.push('Regular: $' + parseFloat(item.regular_price).toFixed(2))
          li.textContent = item.name + (prices.length > 0 ? ' (' + prices.join(', ') + ')' : '')
          this.optionsTarget.appendChild(li)
        })

        if (requirementData.options.selection_mode || requirementData.options.early_price_deadline) {
          const infoLi = document.createElement('li')
          infoLi.className = 'mt-2 text-muted small'
          const infoParts = []
          if (requirementData.options.selection_mode) infoParts.push('Selection: ' + requirementData.options.selection_mode)
          if (requirementData.options.early_price_deadline) infoParts.push('Early deadline: ' + requirementData.options.early_price_deadline)
          infoLi.textContent = infoParts.join(' | ')
          this.optionsTarget.appendChild(infoLi)
        }
      }
    } else if (requirementData.options && Array.isArray(requirementData.options) && requirementData.options.length > 0) {
      hasOptions = true
      requirementData.options.forEach(option => {
        const li = document.createElement('li')
        li.textContent = typeof option === 'string' ? option : JSON.stringify(option)
        this.optionsTarget.appendChild(li)
      })
    }

    this.optionsWrapperTarget.style.display = hasOptions ? 'block' : 'none'

    this.filesTarget.innerHTML = ''

    if (requirementData.files && requirementData.files.length > 0) {
      this.filesWrapperTarget.style.display = 'block'
      requirementData.files.forEach(file => {
        const link = document.createElement('a')
        link.href = file.url
        link.textContent = file.name
        link.className = 'd-block'
        link.target = '_blank'
        this.filesTarget.appendChild(link)
      })
    } else {
      this.filesWrapperTarget.style.display = 'none'
    }
  }
}
